// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-plan-container {
  padding: 30px 14%;
  border-radius: 10px;
  background: linear-gradient(to bottom, #f9f9f9 485px, white 25%);
}

.title {
  text-align: left;
  font-size: 36px;
  font-weight: 500;
  margin-bottom: 25px;
  color: #052456;
}

.subtitle {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
  border-radius: 20px;
  background-color: #fff;
  align-items: start;
}

.plan-details {
  padding: 37px 16px;
}

.add-plan {
  display: flex;
  padding: 21px 16px;
  border: 1px dashed #ddd;
  align-items: self-end;
}

.add-plan:last-child {
  align-items: flex-end;
}

.input {
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 100px;
  font-size: 16px;
  width: 100%;
  box-sizing: border-box;
}

.input:focus {
  border-color: #ff8c00;
  outline: none;
  box-shadow: 0 0 3px rgba(255, 140, 0, 0.5);
}

.custom-select {
  height: 44px;
  border: none;
  border-radius: 100px !important;
  background-color: #fff;
  border: 1px solid #ccc;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
}

.input-label {
  font-size: 14px;
  font-weight: 500;
  color: #191919;
  margin-bottom: 13px;
}

.add-plan-button {
  background-color: #f15e22;
  color: white;
  border: none;
  border-radius: 40px;
  min-height: 48px;
  min-width: 148px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.add-plan-button:hover {
  background-color: #e57800;
}

.plan-item {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 20px;
  margin-bottom: 12px;
  height: 99px;
  background-color: #fff;
}

.plan-value {
  display: flex;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 100px;
  padding-left: 20px;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
}

.plan-added-group {
  width: 100%;
}

.plan-added-item {
  padding-right: 26%;
}

.custom-select-container {
  gap: 15px;
}

.placeholder {
  color: #90777e !important;
}

.error-text {
  position: absolute;
  width: 350px;
  bottom: -20px;
  left: 0;
  font-size: 12px;
  color: red;
}

.create-textarea {
  width: 100%;
  resize: none;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  padding-left: 15px;
  padding-top: 12px;
}

.textarea-container {
  grid-column: span 2;
  position: relative;
}

.textarea-container .error-text {
  bottom: -20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/CreatePlan/createPlan.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gEAAgE;AAClE;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,OAAO;EACP,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".create-plan-container {\n  padding: 30px 14%;\n  border-radius: 10px;\n  background: linear-gradient(to bottom, #f9f9f9 485px, white 25%);\n}\n\n.title {\n  text-align: left;\n  font-size: 36px;\n  font-weight: 500;\n  margin-bottom: 25px;\n  color: #052456;\n}\n\n.subtitle {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 16px;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n  border-radius: 20px;\n  background-color: #fff;\n  align-items: start;\n}\n\n.plan-details {\n  padding: 37px 16px;\n}\n\n.add-plan {\n  display: flex;\n  padding: 21px 16px;\n  border: 1px dashed #ddd;\n  align-items: self-end;\n}\n\n.add-plan:last-child {\n  align-items: flex-end;\n}\n\n.input {\n  padding: 12px;\n  border: 1px solid #ccc;\n  border-radius: 100px;\n  font-size: 16px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.input:focus {\n  border-color: #ff8c00;\n  outline: none;\n  box-shadow: 0 0 3px rgba(255, 140, 0, 0.5);\n}\n\n.custom-select {\n  height: 44px;\n  border: none;\n  border-radius: 100px !important;\n  background-color: #fff;\n  border: 1px solid #ccc;\n}\n\n.field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  position: relative;\n}\n\n.input-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #191919;\n  margin-bottom: 13px;\n}\n\n.add-plan-button {\n  background-color: #f15e22;\n  color: white;\n  border: none;\n  border-radius: 40px;\n  min-height: 48px;\n  min-width: 148px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.add-plan-button:hover {\n  background-color: #e57800;\n}\n\n.plan-item {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 20px;\n  margin-bottom: 12px;\n  height: 99px;\n  background-color: #fff;\n}\n\n.plan-value {\n  display: flex;\n  height: 40px;\n  border: 1px solid #ccc;\n  border-radius: 100px;\n  padding-left: 20px;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.plan-added-group {\n  width: 100%;\n}\n\n.plan-added-item {\n  padding-right: 26%;\n}\n\n.custom-select-container {\n  gap: 15px;\n}\n\n.placeholder {\n  color: #90777e !important;\n}\n\n.error-text {\n  position: absolute;\n  width: 350px;\n  bottom: -20px;\n  left: 0;\n  font-size: 12px;\n  color: red;\n}\n\n.create-textarea {\n  width: 100%;\n  resize: none;\n  border: 1px solid #e3e3e3;\n  border-radius: 10px;\n  padding-left: 15px;\n  padding-top: 12px;\n}\n\n.textarea-container {\n  grid-column: span 2;\n  position: relative;\n}\n\n.textarea-container .error-text {\n  bottom: -20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
